import React, { memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import DynamicIcon from './DynamicIcon';

const Header = memo(({ darkMode, viewMode, toggleViewMode, toggleDarkMode }) => (
  <motion.header 
    initial={{ y: -20, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.4, ease: 'easeOut' }}
    className={`relative rounded-2xl overflow-hidden mb-8
      ${darkMode 
        ? 'bg-[#1a1823] border border-slate-700/50' 
        : 'bg-gradient-to-br from-white to-slate-50 border border-slate-200'}
      shadow-xl shadow-black/10 z-10`}
  >
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500/10 to-transparent"></div>
    
    <div className="relative py-8 px-6 sm:px-10 flex flex-col items-center">
      <div className={`p-4 rounded-2xl ${
        darkMode 
          ? 'bg-[#100f15] border border-slate-700' 
          : 'bg-white/80 border border-slate-200/80'} 
        shadow-lg mb-5`}
      >
        <DynamicIcon name="folder" darkMode={darkMode} className="h-12 w-12" />
      </div>
      
      <div className="text-center">
        <h1 className={`px-1 pb-1 text-4xl sm:text-5xl leading-tight font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r 
            ${darkMode ? 'from-blue-400 to-cyan-400' : 'from-blue-600 to-cyan-500'} 
            mb-2 font-heading`}
        >
          OTA<span className="font-light">Forge</span>
        </h1>
        <p className={`${darkMode ? 'text-slate-400' : 'text-slate-600'} mt-1 text-lg`}>
          Download Portal for AndroidOne Experience
        </p>
      </div>
      
      <div className="absolute top-5 right-5 flex space-x-2">
        <motion.button 
          onClick={toggleViewMode}
          aria-label={viewMode === 'grid' ? "Switch to list view" : "Switch to grid view"}
          whileHover={{ scale: 1.1, rotate: 5 }}
          whileTap={{ scale: 0.9, rotate: -5 }}
          className={`hidden md:block p-2.5 rounded-xl ${darkMode ? 'bg-[#201e2b] border border-slate-700/80 text-slate-300' : 'bg-white/80 border border-slate-200 text-slate-600'}`}
        >
          <AnimatePresence mode="wait">
              <motion.div
                  key={viewMode}
                  initial={{ opacity: 0, rotate: -30, scale: 0.5 }}
                  animate={{ opacity: 1, rotate: 0, scale: 1 }}
                  exit={{ opacity: 0, rotate: 30, scale: 0.5 }}
                  transition={{ duration: 0.2 }}
              >
               {viewMode === 'grid' 
                  ? <DynamicIcon name="list" darkMode={darkMode} className="h-5 w-5" /> 
                  : <DynamicIcon name="grid" darkMode={darkMode} className="h-5 w-5" />}
              </motion.div>
          </AnimatePresence>
        </motion.button>
        
        <motion.button 
          onClick={toggleDarkMode}
          aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          whileHover={{ scale: 1.1, rotate: 5 }}
          whileTap={{ scale: 0.9, rotate: -5 }}
          className={`p-2.5 rounded-xl ${darkMode ? 'bg-[#201e2b] border border-slate-700/80 text-slate-300' : 'bg-white/80 border border-slate-200 text-slate-600'}`}
        >
          <AnimatePresence mode="wait">
            <motion.div
                key={darkMode ? 'moon' : 'sun'}
                initial={{ opacity: 0, rotate: -30, scale: 0.5 }}
                animate={{ opacity: 1, rotate: 0, scale: 1 }}
                exit={{ opacity: 0, rotate: 30, scale: 0.5 }}
                transition={{ duration: 0.2 }}
            >
              {darkMode 
                ? <DynamicIcon name="sun" darkMode={darkMode} className="h-5 w-5" /> 
                : <DynamicIcon name="moon" darkMode={darkMode} className="h-5 w-5" />}
            </motion.div>
          </AnimatePresence>
        </motion.button>
      </div>
    </div>
  </motion.header>
));

export default Header;
